import { api } from '../api';
import { IdCompany } from '../../contexts/auth';

export async function getAllGroups() {
    try {
        const { data } = await api.get(`/group`)
        if (data[0]?.error) return null
        return data;
    }
    catch (error) {
        return null;
    }
};
export async function getGroupsUser(id) {
    try {
        const { data: { grupos } } = await api.get(`/group-user?user_id=${id}`)
        if (grupos[0]?.error) return null
        return grupos;
    }
    catch (error) {
        return null;
    }
};
export async function getUsersGroup(id) {
    try {
        const { data: { usuarios } } = await api.get(`/group-users?group_id=${id}`)
        if (usuarios[0]?.error) return null
        return usuarios;
    }
    catch (error) {
        return null;
    }
};
export async function getMyChatsInGroup(id) {
    try {
        const { data } = await api.get(`/customerservice/group?usuario_id=${id}&aberto=S`)
        if (data[0]?.error) return false
        return data;
    }
    catch (error) {
        return false;
    }
};
export async function getTagsGroup(id) {
    try {
        const { data } = await api.get(`customerservice/group-tags?usuario_id=${id}&aberto=S`)
        if (data[0]?.error) return false
        return data;
    }
    catch (error) {
        return false;
    }
};
export async function createGroup(name) {
    try {
        const { status, data: { message, data: { user_id } } } = await api.post(
            `group?name=${name}&empresa_id=${IdCompany()}`
        )
        if (status !== 500) {
            return {
                status_code: 200,
                message: message,
                id: user_id
            };
        } else {
            return {
                status_code: 500,
                message: message,
                id: null
            };
        }
    }
    catch (error) {
        if (error.response.status === 403) {
            return {
                status_code: 500,
                message: 'Setor já cadastrado !',
                id: null
            };
        }
        return {
            status_code: 500,
            message: 'Não foi possível criar o setor !',
            id: null
        };
    }
};
export async function linkedUsersToGroup(groupID, users) {
    try {
        const { status, data: { message } } = await api.post(
            `/multiuser-group?group_id=${groupID}&user_id=${users}`
        )
        if (status !== 500) {
            return {
                status_code: 200,
                message: message
            };
        } else {
            return {
                status_code: 500,
                message: message
            };
        }
    }
    catch (error) {
        return {
            status_code: 500,
            message: 'Não foi possível vincular usuários !'
        };
    }
};
export async function linkedGroupToUser(userID, groups) {
    try {
        const { data } = await api.post(`/group-user?group_id=${groups}&user_id=${userID}`)
        return data;
    }
    catch (error) {
        return false;
    }
};
export async function removeLinkGroupToUser(userID, idGroup) {
    try {
        const { data } = await api.delete(`/group-user?group_id=${idGroup}&user_id=${userID}`)
        return data;
    }
    catch (error) {
        return false;
    }
};
export async function removeLinkBetweenUsersAndGroup(idGroup, usersIDs) {
    try {
        const { data } = await api.delete(`/users-group?group_id=${idGroup}&user_id=${usersIDs}`)
        return data;
    }
    catch (error) {
        return false;
    }
};

export async function renameGroup({id, name}) { 
    try {
        const { data } = await api.put(`/user/${id}?user_id=${id}&name=${name}`)
        if (data?.status_code === 200) {
            return true;
        }
        return false;
    }
    catch (error) {
        return false;
    }
}